import React, { useEffect, useRef, useState, useCallback } from "react";
import axios from "../../API/axios";
import { business, NewsFeed, post, people } from "../../config/imagesLink";
import { Col, Dropdown, NavLink, Row } from "react-bootstrap";
import Followers from "../../Views/BusinessPage/Followers";
import Jobs from "../../Views/BusinessPage/Jobs";
import Posts from "../../Views/BusinessPage/Posts";
import AboutCompany from "./AboutCompany";
import { Link, useNavigate, useParams } from "react-router-dom";
import ModalForGuest from "../ModalForGuest";
import SuccessToast from "../SuccessToast";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";
import Reviews from "./Reviews";
import { ShimmerThumbnail } from "react-shimmer-effects";
import { userAuthImage } from "../../config/imagesLink";
import { ShimmerDiv } from "@skeleton";
import CompanyActions from "../MyCompanies/CompanyActions";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import InfoSharpIcon from "@mui/icons-material/InfoSharp";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import PersonAddAlt1SharpIcon from "@mui/icons-material/PersonAddAlt1Sharp";
import PersonRemoveAlt1SharpIcon from "@mui/icons-material/PersonRemoveAlt1Sharp";
import DeleteSharpIcon from "@mui/icons-material/DeleteSharp";
import Cropper from "react-easy-crop";
import getCroppedImg from "../PersonalProfile/cropImage";
import { Helmet } from "react-helmet";
import ProfileNegativeActions from "../PersonalProfile/ProfileNegativeActions";
import useNewsFeedStore from "../NewsFeed/useNewsFeedStore";
import { useTranslation } from "react-i18next";
import WarningAmberSharpIcon from "@mui/icons-material/WarningAmberSharp";
import GoogleAdUnit from "../../components/GoogleAdUnit";
import { Portal } from "../../components/Portal";

const COMPANY_TAB_MAP = {
  about: 1,
  posts: 2,
  jobs: 3,
  followers: 4,
  review: 5,
};

const COMPANY_TAB_ROUTES = {
  1: "About",
  2: "Posts",
  3: "Jobs",
  4: "Followers",
  5: "Review",
};

const isCompanyTabSegment = (value) =>
  Boolean(COMPANY_TAB_MAP[String(value || "").toLowerCase()]);

const getCompanyTabIndex = (routeTab, slugParam) => {
  const resolvedTab = routeTab || (isCompanyTabSegment(slugParam) ? slugParam : "");
  const tabKey = String(resolvedTab || "").toLowerCase();
  return COMPANY_TAB_MAP[tabKey] || 1;
};

const getCompanySlug = (slugParam) => {
  if (!slugParam || isCompanyTabSegment(slugParam)) return "";
  return slugParam;
};


const BusinessPage = ({ setProgress, setIsVideoProcessing }) => {
  // Local states

  const sessionId = localStorage.getItem("sessionId");
  const guestModeData = localStorage.getItem("guestMode");
  const getUserID = localStorage.getItem("userUid");
  const { CompUid, slug: slugParam, tab: routeTab } = useParams();
  const companySlug = getCompanySlug(slugParam);
  const resolvedRouteTab =
    routeTab || (isCompanyTabSegment(slugParam) ? slugParam : "");
  const navigate = useNavigate();
  const { t } = useTranslation();

  //   States for Review Modal
  const [showReviewModal, setShowReviewModal] = useState(false);
  const handleCloseReviewModal = () => setShowReviewModal(false);
  const handleShowReview = () => setShowReviewModal(true);
  const [reviewContent, setReviewContent] = useState("");

  //   Toaster's State
  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);
  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);
  const [companyError, setCompanyError] = useState(false);
  const [companyDetails, setCompanyDetails] = useState("");
  const language = localStorage.getItem("Lang");

  const [checkblockC, setcheckblockC] = useState(companyDetails?.isBlockedByYou)

  useEffect(() => {
    setcheckblockC(companyDetails?.isBlockedByYou === true);
  }, [companyDetails?.isBlockedByYou]);

  const handleCompanyLogoError = (e) => {
    if (!e || !e.target) return;
    e.target.onerror = null;
    e.target.src = people.DefaultProfile;
  };

  const companyLogoSrc = companyDetails?.logoImage || people.DefaultProfile;
  
  const CompanyDetails = async () => {
    setIsLoading(true);
    setCompanyError(false);
    try {
      const result = await axios.post(`Company/GetCompanyDetails`, {
        deviceType: "Web",
        compUid: CompUid,
        langKey: language === "en" ? "" : language,
      });

      if (result?.status === 204) {
        setCompanyDetails("");
        setOwnedCompanyDetails("");
        setCompanyError(true);
      } else {
        const Response = result?.data?.responseData;

        if (!Response?.compUid || Response?.isDeleted) {
          setCompanyDetails("");
          setOwnedCompanyDetails("");
          setCompanyError(true);
        } else {
          setCompanyDetails(Response);
          setOwnedCompanyDetails(Response?.isOwned);
        }
      }
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setCompanyDetails("");
      setOwnedCompanyDetails("");
      setCompanyError(true);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    CompanyDetails();
  }, [CompUid]);
  //   For Tab
  const [activeTab, setActiveTab] = useState(() =>
    getCompanyTabIndex(resolvedRouteTab, slugParam)
  );

  const getCompanyBasePath = () =>
    companySlug ? `/Company/${CompUid}/${companySlug}` : `/Company/${CompUid}`;

  const goToCompanyTab = (tabIndex) => {
    setActiveTab(tabIndex);
    const tabPath = COMPANY_TAB_ROUTES[tabIndex];
    if (tabPath) {
      navigate(`${getCompanyBasePath()}/${tabPath}`);
    }
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case 1:
        return (
          <AboutCompany CompUid={CompUid} companyDetails={companyDetails} />
        );
      case 2:
        return <Posts CompUid={CompUid} companyDetails={companyDetails}
          setIsVideoProcessing={setIsVideoProcessing}
          setProgress={setProgress} setCompanyStats={setCompanyStats} CompanyStatsCount={CompanyStatsCount} />;
      case 3:
        return <Jobs CompUid={CompUid} companyDetails={companyDetails} setCompanyStats={setCompanyStats} companyStats={companyStats} />;
      case 4:
        return <Followers CompUid={CompUid} />;
      case 5:
        return (
          <Reviews
            CompUid={CompUid}
            companyDetails={companyDetails}
            CompanyDetails={CompanyDetails}
            setJobModal={setJobModal}
            handleShowReview={handleShowReview}
            CompanyStatsCount={CompanyStatsCount}
          />
        );
      default:
        return null;
    }
  };

  useEffect(() => {
    const nextRouteTab =
      routeTab || (isCompanyTabSegment(slugParam) ? slugParam : "");
    setActiveTab(getCompanyTabIndex(nextRouteTab, slugParam));
  }, [routeTab, slugParam]);

  //   Get company details

  const [ownedCompanyDetails, setOwnedCompanyDetails] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const [jobModal, setJobModal] = useState(false);
  const closeModalData = () => {
    setJobModal(false);
  };

  //   Company job alert check
  const [jobAlert, setJobAlert] = useState("");
  const [makeJobAlertConfirm, setMakeJobAlertConfirm] = useState("");

  const CompanyJobAlertCheck = async () => {
    try {
      const result = await axios.post(`Company/CheckCompJobAlert`, {
        deviceType: "Web",
        compUid: CompUid,
        sessionId,
        langKey: language === "en" ? "" : language,
      });
      const Response = result.data.message;
      setMakeJobAlertConfirm(Response);
      setJobAlert(Response);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  useEffect(() => {
    const sessionId = localStorage.getItem("sessionId");
    if (sessionId) {
      CompanyJobAlertCheck();
    }
  }, [CompUid]);

  //   Mark job alert
  const [markAlert, setMarkAlert] = useState("");
  const markJobAlert = async () => {
    try {
      const response = {
        deviceType: "Web",
        sessionId,
        compUid: CompUid,
        langKey: language === "en" ? "" : language,
      };
      const result = await axios.post(`Company/AddCompJobAlert`, response);
      setMarkAlert(result.data.message);
      setToastMessage(result.data.message);
      setShowToast(true);
      CompanyJobAlertCheck();
    } catch (e) {
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  //   Unmark job alert
  const unMarkJobAlert = async () => {
    try {
      const response = {
        deviceType: "Web",
        sessionId,
        compUid: CompUid,
        langKey: language === "en" ? "" : language,
      };
      const result = await axios.post(`Company/DeleteCompJobAlert`, response);
      setToastMessage(result.data.message);
      setShowToast(true);
      CompanyJobAlertCheck();
    } catch (e) {
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  //************************ Follow Company  ************************//

  const [followC, setFollowC] = useState(companyDetails?.isFollowedByYou)

  const FollowCompany = async () => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      uiD_ID: CompUid,
      langKey: language === "en" ? "" : language,
    };
    try {
      await axios.post("Entity/Follow/Company", data).then((resData) => {
        // CompanyDetails();
        setToastMessage(resData.data.message);
        setShowToast(true);
        setFollowC(true)
      });
    } catch (e) {
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  //************************ UnFollow Company  ************************//

  const UnFollowCompany = async (id) => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      uiD_ID: CompUid,
      langKey: language === "en" ? "" : language,
    };
    try {
      await axios.post("Entity/Unfollow/Company", data).then((resData) => {
        setToastMessage(resData.data.message);
        setShowToast(true);
        setFollowC(false)
        handleCloseModal();
        // CompanyDetails();
      });
    } catch (e) {
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response.data.message);
        setShowErrorToast(true);
      }
    }
  };
  //************************ Company tats Count ************************//

  const [companyStats, setCompanyStats] = useState("");
  const [companyPostCount, setCompanyPostCount] = useState();

  const CompanyStatsCount = async () => {
    try {
      const response = {
        deviceType: "Web",
        compUid: CompUid,
        langKey: language === "en" ? "" : language,
      };
      const result = await axios.post(`Company/GetCompanyStats`, response);
      const Response = result?.data?.responseData;

      setCompanyStats(Response);
      localStorage.setItem("companyJobCount", Response?.totalJobs);
      // console.log("CompanyPostDetails",Response?.totalJobs)
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    CompanyStatsCount();
  }, [CompUid]);

  //************************ Add review ************************//

  const AddReview = async () => {
    const reviewData = {
      deviceType: "Web",
      sessionId: sessionId,
      compUid: CompUid,
      review: reviewContent,
      rating: 0,
      langKey: language === "en" ? "" : language,
    };
    try {
      await axios.post("Company/AddCompanyReview", reviewData).then((res) => {
        setToastMessage(res.data.message);
        setShowToast(true);
        setShowReviewModal(false);
        setReviewContent();
        setShowDropdown(false);
        CompanyDetails();
        CompanyStatsCount();
      });
    } catch (e) {
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  //   State and function for Bg
  const [openBgModal, setOpenBgModal] = useState(false);
  const [openProfileModal, setOpenProfileModal] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(null);
  const [deleteModal, setDeleteModal] = useState(null);

  const closeViewerModals = () => {
    setOpenBgModal(false);
    setOpenProfileModal(false);
  };

  const handleOpen = (event) => {
    event?.stopPropagation?.();
    if (showUpdateModal || deleteModal) return;
    setOpenProfileModal(false);
    setOpenBgModal(true);
  };
  const handleScroll = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  const handleOpenBgCloseModal = () => {
    setOpenBgModal(false);
  };

  const handleOpenProfileCloseModal = () => {
    setOpenProfileModal(false);
  };

  const handleOpenUpdate = (compUid) => {
    closeViewerModals();
    setShowUpdateModal(compUid);
  };
  const handleClose = () => setShowUpdateModal(null);

  const openDeleteModal = (compUid) => {
    closeViewerModals();
    setDeleteModal(compUid);
  };
  const closeDeleteModal = () => {
    setDeleteModal(null);
  };

  // cropping flags (declare before effects that reference them)
  const [showBgCropper, setShowBgCropper] = useState(false);
  const [bgCroppedAreaPixels, setBgCroppedAreaPixels] = useState(null);
  const [showProfileCropper, setShowProfileCropper] = useState(false);
  const [profileCroppedAreaPixels, setProfileCroppedAreaPixels] = useState(null);

  //   For to overflow scoll handle
  useEffect(() => {
    if (showReviewModal || openBgModal || openProfileModal || jobModal || showBgCropper || showProfileCropper || showUpdateModal || deleteModal) {
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
      document.body.classList.add("modal-open");
    } else {
      document.body.style.overflow = "unset";
      document.documentElement.style.overflow = "";
      document.body.classList.remove("modal-open");
    }
  }, [showReviewModal, openBgModal, openProfileModal, jobModal, showBgCropper, showProfileCropper, showUpdateModal, deleteModal]);

  //   State for Dropdown
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);
  const handleToggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  //   For Unfollow user
  const [showModal, setShowModal] = useState(false);
  const handleCloseModal = () => setShowModal(false);
  const handleUnfollow = () => {
    if (guestModeData === "true") {
      setJobModal(true);
    } else {
      setShowModal(true)
      // UnFollowCompany();
    }
    setShowDropdown(false);
  };

  //   For Unmark job alert
  const handleUnmarkJobAlert = () => {
    if (guestModeData === "true") {
      setJobModal(true);
    } else {
      unMarkJobAlert();
    }
    setShowDropdown(false);
  };

  useEffect(() => {
    handleScroll();
  }, []);

  //************************ Background Image   ************************//
  const [bgSelectedImage, setBgSelectedImage] = useState(null);
  const [bgSourceImage, setBgSourceImage] = useState(null);
  const [bgCropImage, setBgCropImage] = useState(null);
  const [backgroundImage, setBackgroundImage] = useState(null);
  const [isloading, setIsloading] = useState(false);

  // console.log(backgroundImage);
  const [bgModal, setBgModal] = useState(false);
  const handleBgModal = () => {
    setBgModal(false);
  };
  const fileInputRefBg = useRef(null);
  const handleBgClick = () => {
    fileInputRefBg.current.click();
  };
  const handleBgImageChange = (event) => {
    const selectedFile = event.target.files[0];
    if (!selectedFile) return;
    const reader = new FileReader();
    reader.onload = () => {
      const dataUrl = reader.result;
      setBackgroundImage(selectedFile);
      setBgSelectedImage(dataUrl);
      setBgSourceImage(dataUrl);
      setBgCropImage(dataUrl);
      try { sessionStorage.setItem("tempBgImage", dataUrl); } catch (e) {}
      setCrop({ x: 0, y: 0 });
      setZoom(1);
      setRotation(0);
      setShowBgCropper(true);
    };
    reader.readAsDataURL(selectedFile);
    event.target.value = "";
  };

  const onBgCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setBgCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const saveBgCroppedImage = async () => {
    try {
      const sourceImage = bgCropImage || bgSelectedImage;
      const croppedImageUrl = await getCroppedImg(
        sourceImage,
        bgCroppedAreaPixels,
        rotation
      );
      const response = await fetch(croppedImageUrl);
      const blob = await response.blob();
      const file = new File([blob], "cropped-bg.jpg", { type: blob.type });
      setBackgroundImage(file);
      setBgSelectedImage(croppedImageUrl);
      try { sessionStorage.setItem("tempBgImage", croppedImageUrl); } catch (e) {}
      setBgCropImage(null);
      setShowBgCropper(false);
      setBgModal(true);
    } catch (e) {
      console.error("Error cropping image:", e);
      setShowBgCropper(false);
      setBgModal(true);
    }
  };

  const cancelBgCropping = () => {
    setShowBgCropper(false);
    setBgModal(true);
  };

  const deleteBgSelection = () => {
    setBgSelectedImage(null);
    setBackgroundImage(null);
    setBgModal(false);
  };

  const BgImageUpload = async () => {

    try {
      if (backgroundImage !== null) {
        setIsloading(true);

        const formData = new FormData();
        formData.append("DeviceType", "Web");
        formData.append("sessionId", sessionId);
        formData.append("BackGroundImage", backgroundImage);
        formData.append("CompUid", CompUid);
        formData.append("LangKey", language === "en" ? "" : language,);
        const res = await axios.post(
          "/Company/SetCompanyBackgroundImage",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        // console.log("response: ", res.data.responseData);
        // toast.success(res.data.message);
        setToastMessage(res.data.message);
        setShowToast(true);
        setBgModal(false);
        setIsloading(false);
        CompanyDetails();
        // getUserProfile()
        // userConfig();
      }
    } catch (error) {
      setIsloading(false);
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
      }
    }
  };
  //************************ Background Image End  ************************//

  const [showToolbar, setShowToolbar] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 200) {
        setShowToolbar(true);
      } else {
        setShowToolbar(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  //************************ Profile Picture   ************************//
  const [selectedprofileImage, setselectedprofileImage] = useState(null);
  const [profileSourceImage, setProfileSourceImage] = useState(null);
  const [profileCropImage, setProfileCropImage] = useState(null);
  const [profileImage, setprofileImage] = useState(null);
  const [loading, setLoading] = useState(false);
  // console.log(profileImage);
  const [profileModal, setprofileModal] = useState(false);
  const handleprofileModal = () => {
    setprofileModal(false);
  };
  const fileInputRefprofile = useRef(null);
  const handleProfileClick = () => {
    fileInputRefprofile.current.click();
  };
  const handleProfileImageChange = (event) => {
    const selectedFile = event.target.files[0];
    if (!selectedFile) return;
    const reader = new FileReader();
    reader.onload = () => {
      const dataUrl = reader.result;
      setprofileImage(selectedFile);
      setselectedprofileImage(dataUrl);
      setProfileSourceImage(dataUrl);
      setProfileCropImage(dataUrl);
      try { sessionStorage.setItem("tempProfileImage", dataUrl); } catch (e) {}
      setCrop({ x: 0, y: 0 });
      setZoom(1);
      setRotation(0);
      setShowProfileCropper(true);
    };
    reader.readAsDataURL(selectedFile);
    event.target.value = "";

  };

  // cropping UI for company profile picture
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [rotation, setRotation] = useState(0);
  

  const onProfileCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setProfileCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const saveProfileCroppedImage = async () => {
    try {
      const sourceImage = profileCropImage || selectedprofileImage;
      const croppedImageUrl = await getCroppedImg(
        sourceImage,
        profileCroppedAreaPixels,
        rotation
      );
      // convert object URL to File
      const response = await fetch(croppedImageUrl);
      const blob = await response.blob();
      const file = new File([blob], "cropped-profile.jpg", { type: blob.type });
      setprofileImage(file);
      setselectedprofileImage(croppedImageUrl);
      try { sessionStorage.setItem("tempProfileImage", croppedImageUrl); } catch (e) {}
      setProfileCropImage(null);
      setShowProfileCropper(false);
      setprofileModal(true);
    } catch (e) {
      console.error("Error cropping profile image:", e);
      setShowProfileCropper(false);
    }
  };

  const cancelProfileCropping = () => {
    // close cropper and show preview (don't clear selection)
    setShowProfileCropper(false);
    setprofileModal(true);
  };

  const deleteProfileSelection = () => {
    setselectedprofileImage(null);
    setprofileImage(null);
    setprofileModal(false);
  };

  const ProfileImageUpload = async () => {
    try {
      if (profileImage !== null) {
        setLoading(true);
        const formData = new FormData();
        formData.append("DeviceType", "Web");
        formData.append("sessionId", sessionId);
        formData.append("CompanyLogo", profileImage);
        formData.append("CompUid", CompUid);
        formData.append("Language", language === "en" ? "" : language,);
        const res = await axios.post("/Company/SetCompanyLogo", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        console.log("response: ", res.data.responseData);
        // toast.success(res.data.message);
        setToastMessage(res.data.message);
        setShowToast(true);
        setprofileModal(false);
        setLoading(false);
        // getUserProfile()
        CompanyDetails();
        // userConfig();
      }
    } catch (error) {
      setLoading(false);
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
      }
    }
  };
  //************************ Profile Picture End  ************************//
  const [show, setShow] = useState(false);

  console.log("companyDetails", companyDetails);

  // -------------------------------------------------------------------------
  const { setIsNewsPageLoaded } = useNewsFeedStore();

  useEffect(() => {
    setIsNewsPageLoaded(true); // enable right panel when entering NewsFeed

    return () => setIsNewsPageLoaded(false); // optional cleanup when leaving
  }, [setIsNewsPageLoaded]);

  // -------------------------------------------------------------------------

  const hasCompanyDetails = Boolean(companyDetails?.compUid && !companyDetails?.isDeleted);




  return (
    <>
      <Helmet>
        <title>{`${companyDetails?.compName}`} Profile | Welinkjobs</title>
        <meta name="description" content={`${companyDetails?.about}`} />
        <meta name="keywords" content="newsfeed, updates, latest news" />
        <meta
          property="og:title"
          content={`${companyDetails?.compName} Profile | Welinkjobs`}
        />
        <meta property="og:description" content={`${companyDetails?.about}`} />
        <meta property="og:url" content="https://welinkjobs.com/NewsFeeds" />
      </Helmet>

      {isLoading ? (
        <>
          <ShimmerDiv height={100} width={"100%"} />
        </>

      ) : (
        <>
          {companyError || !hasCompanyDetails ? (
            <div className=" mt-5 text-center">
              <p className="mt-5">{t("modals.There is no data, Kindly enable the company from")} .
                <Link to="/MyCompanies"> {t("Sidemenubar.Manage")}</Link>
              </p>
            </div>
          ) : (
            <div
              className="card profileCard desktopView mt-3"
            >
              <div className="Profilebackground">
                <div
                  className="background-overlay"
                  onClick={handleOpen}
                >
                  <img src={companyDetails?.backGroundImage} alt="Background" />
                  {companyDetails?.isOwned && (
                    <>
                      {/* Replace label with a div to avoid automatic click handling */}
                      <div
                        className="backgroundimg-edit"
                        onClick={(event) => {
                          event.stopPropagation(); // Prevent the parent onClick from firing
                          handleBgClick(); // Trigger the file input click
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        <EditSharpIcon className="material-symbols-sharp" />
                      </div>
                    </>
                  )}
                </div>
                <input
                  type="file"
                  ref={fileInputRefBg}
                  style={{ display: "none" }}
                  onChange={handleBgImageChange}
                  accept="image/*"
                />
              </div>
              <div
                className="profileImg"
                onClick={() => {
                  if (showUpdateModal || deleteModal) return;
                  setOpenBgModal(false);
                  setOpenProfileModal(true);
                }}
              >
                <img
                  src={companyLogoSrc}
                  alt=""
                  style={{ borderRadius: "50px" }}
                  onError={handleCompanyLogoError}
                />
                {companyDetails?.isOwned && (
                  <>
                    <label
                      htmlFor="fileInput"
                      className="background-edit"
                      onClick={(event) => {
                        event.stopPropagation();
                        handleProfileClick();
                      }}
                    >
                      <EditSharpIcon className="material-symbols-sharp" />
                    </label>
                  </>
                )}
                <input
                  type="file"
                  ref={fileInputRefprofile}
                  style={{ display: "none" }}
                  onChange={handleProfileImageChange}
                  accept="image/*"
                  onClick={(event) => {
                    event.stopPropagation();
                  }}
                />
              </div>

              <div className="companyPage profileDetails">
                <h4>
                  {companyDetails?.compName}
                </h4>
                <p>
                  {companyDetails?.industryName}
                </p>
                <p>
                  {companyDetails?.companyCategoryName}
                </p>
                <div className="d-flex align-items-center">
                  <div className="  badge-vip ms-0 me-2">
                    {companyDetails?.compUid}{" "}
                  </div>
                  {companyDetails?.isOwned && (
                    <CompanyActions
                      showUpdateModal={showUpdateModal}
                      setShow={setShow}
                      handleClose={handleClose}
                      handleOpenUpdate={handleOpenUpdate}
                      show={show}
                      setShowUpdateModal={setShowUpdateModal}
                      compUid={companyDetails?.compUid}
                      getCompanyList={CompanyDetails}
                      item={companyDetails}
                      setDeleteModal={setDeleteModal}
                      openDeleteModal={openDeleteModal}
                      closeDeleteModal={closeDeleteModal}
                      deleteModal={deleteModal}
                      renderDialogs
                      onCompanyDeleted={() => {
                        setCompanyDetails("");
                        setOwnedCompanyDetails("");
                        setCompanyError(true);
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
          )}

          {hasCompanyDetails && (isLoading ? (
            <>
              <ShimmerDiv height={100} width={"100%"} />
            </>
          ) : (
            <div
              className="card profileCard mobileView"
            >
              <div className="Profilebackground">
                <div
                  className="background-overlay"
                  onClick={handleOpen}
                >
                  <img src={companyDetails?.backGroundImage} alt="Background" />
                  {companyDetails?.isOwned && (
                    <>
                      {/* Replace label with a div to avoid automatic click handling */}
                      <div
                        className="backgroundimg-edit"
                        onClick={(event) => {
                          event.stopPropagation(); // Prevent the parent onClick from firing
                          handleBgClick(); // Trigger the file input click
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        <EditSharpIcon className="material-symbols-sharp" />
                      </div>
                    </>
                  )}
                </div>
                <input
                  type="file"
                  ref={fileInputRefBg}
                  style={{ display: "none" }}
                  onChange={handleBgImageChange}
                  accept="image/*"
                />
              </div>
              <div
                className="profileImg"
                onClick={() => {
                  if (showUpdateModal || deleteModal) return;
                  setOpenBgModal(false);
                  setOpenProfileModal(true);
                }}
              >
                <img
                  src={companyLogoSrc}
                  alt=""
                  style={{ borderRadius: "50px" }}
                  onError={handleCompanyLogoError}
                />
                {companyDetails?.isOwned && (
                  <>
                    <label
                      htmlFor="fileInput"
                      className="background-edit"
                      onClick={(event) => {
                        event.stopPropagation();
                        handleProfileClick();
                      }}
                    >
                      <EditSharpIcon className="material-symbols-sharp" />
                    </label>
                  </>
                )}
                <input
                  type="file"
                  ref={fileInputRefprofile}
                  style={{ display: "none" }}
                  onChange={handleProfileImageChange}
                  accept="image/*"
                  onClick={(event) => {
                    event.stopPropagation();
                  }}
                />
              </div>

              <div className="companyPage profileDetails-mb pt-4  p-2 text-center">
                <h4>{companyDetails?.compName}</h4>
                <div className="d-flex align-items-center justify-content-center">
                  <div className="badge-vip ms-0 me-2">
                    {companyDetails?.compUid}{" "}
                    <InfoSharpIcon className="material-symbols-sharp ms-3" />
                  </div>
                  {companyDetails?.isOwned && (
                    <CompanyActions
                      showUpdateModal={showUpdateModal}
                      setShowUpdateModal={setShowUpdateModal}
                      handleClose={handleClose}
                      handleOpenUpdate={handleOpenUpdate}
                      compUid={companyDetails?.compUid}
                      getCompanyList={CompanyDetails}
                      item={companyDetails}
                      setDeleteModal={setDeleteModal}
                      openDeleteModal={openDeleteModal}
                      closeDeleteModal={closeDeleteModal}
                      deleteModal={deleteModal}
                      renderDialogs={false}
                      onCompanyDeleted={() => {
                        setCompanyDetails("");
                        setOwnedCompanyDetails("");
                        setCompanyError(true);
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
          )
          )}

          {hasCompanyDetails && <div className="">
            {/* ************************  For desktopView ************************ */}
            {isLoading ? (
              <>
                <ShimmerDiv height={200} width={"100%"} />
              </>
            ) : (
              <div className="followerTabs d-flex align-items-center justify-content-between followerTabsNews">
               {companyDetails?.isBlockedByYou === false ?
              ( <>
               {companyDetails?.isOwned === false ? (
                  <div className="businessCardButton d-flex ms-2  p-2 ps-0 pe-0 followerTabsNewsInnerbusinessCardButton">
                    <>
                      {companyDetails?.isFollowedByYou === true || followC === true ? (
                        <button
                          type="submit"
                          className="wljDangerBtn me-2 wlj-chip-btn business-action-btn"
                          onClick={() => {
                            handleUnfollow();
                          }}
                        >
                          <PersonRemoveAlt1SharpIcon />
                          {t("Companies.Unfollow")}
                        </button>
                      ) : (
                        <button
                          className="wljPrimaryBtn me-2 wlj-chip-btn business-action-btn"
                          onClick={() =>
                            guestModeData === "true"
                              ? setJobModal(true)
                              : FollowCompany()
                          }
                        >
                          <PersonAddAlt1SharpIcon />
                          {t("Companies.Follow")}
                        </button>
                      )}

                      {jobAlert === "Company job alert found!" ? (
                        <button
                          type="submit"
                          className="wljDangerBtn wlj-chip-btn business-action-btn"
                          onClick={() => {
                            handleUnmarkJobAlert();
                          }}
                        >
                          {t("Newsfeed.Unmark Job Alert")}
                        </button>
                      ) : (
                        <button
                          className="mainBtn1 me-1 markBtn wlj-chip-btn business-action-btn"
                          onClick={() =>
                            guestModeData === "true"
                              ? setJobModal(true)
                              : markJobAlert()
                          }
                        >
                          {t("Newsfeed.Mark Job Alert")}
                        </button>
                      )}
                      <ProfileNegativeActions
                        userData={null}
                        companyDetails={companyDetails}
                        type="company"
                        CompanyDetailsApiCall={CompanyDetails}
                        CompUid={CompUid}
                        setCompanyDetails={setCompanyDetails}
                        checkblockC={checkblockC}
                        setcheckblockC={setcheckblockC}
                      />
                    </>
                  </div>
                ) : (
                  <>
                    <div style={{ marginLeft: '30%' }}></div>
                  </>
                )} 
               </> ) : ( 
                <div className="businessCardButton blocked-action-banner d-flex followerTabsNewsInnerbusinessCardButton align-items-center">
                  <p className="warningText d-flex mb-0 align-items-center new-warningText blocked-action-warning">
                    <WarningAmberSharpIcon className="material-symbols-sharp flex-shrink-0" />
                    <span className="blocked-action-warning-text">
                      {t("User Profile.You have blocked this company")}{" "}
                      <Link to="/settings/blockedCompany" className="link-style">
                        {t("User Profile.Unblock from settings")}
                      </Link>
                    </span>
                  </p>
                </div>
               )
                }
                
                <div className="tabButton d-flex justify-content-around 00 me-2 pt-2 w-70 IncreaseWidthw-70 followerTabsNewsInnertabButton" >
                  <NavLink
                    // onClick={() => setActiveTab(1)}
                    onClick={() => goToCompanyTab(1)}
                    className={`text-center ${activeTab === 1 ? "activeTab" : ""
                      }`}
                  >
                    {/* <p className="f-12 tabCountFollower">
                        {companyStats?.totaPosts}
                      </p> */}
                    <div>
                      <p className="f-12 tabCountFollower">
                      </p>
                      <p className="f-10 tabName">{t("User Profile.About")}  </p>
                    </div>
                  </NavLink>
                  <NavLink
                    // onClick={() => setActiveTab(2)}
                    onClick={() => goToCompanyTab(2)}
                    className={`text-center ${activeTab === 2 ? "activeTab" : ""
                      }`}
                  >
                    <div>
                      <p className="f-12 tabCountFollower">
                        {companyStats?.totalPosts}
                      </p>
                      <p className="f-10 tabName">{t("User Profile.Post")}</p>
                    </div>
                  </NavLink>
                  <NavLink
                    // onClick={() => setActiveTab(3)}
                    onClick={() => goToCompanyTab(3)}
                    className={`text-center ${activeTab === 3 ? "activeTab" : ""
                      }`}
                  >
                    <div>
                      <p className="f-12 tabCountFollower">
                        {companyStats?.totalJobs}
                      </p>
                      <p className="f-10 tabName"> {t("User Profile.Jobs")}</p>
                    </div>
                  </NavLink>
                  <NavLink
                    // onClick={() => setActiveTab(4)}
                    onClick={() => goToCompanyTab(4)}
                    className={`text-center ${activeTab === 4 ? "activeTab" : ""
                      }`}
                  >
                    <div>
                      <p className="f-12  tabCountFollower">
                        {companyStats?.totalFollowers}
                      </p>
                      <p className="f-10 tabName">{t("User Profile.Followers")}</p>
                    </div>
                  </NavLink>
                  <NavLink
                    // onClick={() => setActiveTab(5)}
                    onClick={() => goToCompanyTab(5)}
                    className={`text-center ${activeTab === 5 ? "activeTab" : ""
                      }`}
                  >
                    <div>
                      <p className="f-12  tabCountFollower">
                        {companyStats?.totaPostsReviews}
                      </p>
                      <p className="f-10 tabName"> {t("User Profile.Reviews")}</p>
                    </div>
                  </NavLink>
                </div>
              </div>
            )}

            {/* ************************  For Mobile ************************ */}
          </div>}


          {hasCompanyDetails && <div className="row mt-3 mainProfileContainer wlj-company-jobs-row">

            <div className="col-lg-4 col-md-12 newsfeedPosts wlj-company-ads-col">
              <div className="ad-container">
                <div className="AdwrapperwithText">
                  <div
                    className={`ad-wrapper`}
                    style={{
                      width: "100%",
                      height: "300px",
                      // overflow: "hidden",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <GoogleAdUnit
                      adSlot="9135916775"
                      style={{
                        display: "block",
                        width: "100%",
                        minHeight: "300px",
                        margin: "0 auto",
                      }}
                    />
                  </div>
                  <h1 className="adText">{t("Newsfeed.Advertisement")}</h1>
                </div>
              </div>

            </div>
            <div className="col-lg-8 col-md-12 profileTabContent wlj-company-jobs-col">
              {isLoading ? (
                <>
                  <ShimmerDiv height={200} width={"100%"} />
                </>
              ) : (
                <div className="websiteCont-Outer">{renderTabContent()}</div>
              )}
            </div>

          </div>}
          {/* <div className="business-main-container position-relative mt-3">
            <div className="sub-content-container">
              <Row style={{ width: "100%" }}>
                <Col
                  md={4}
                  xs={12}
                  className="mobile-view"
                >
                  <div className="AdwrapperwithText">
                    <div
                      className={`ad-wrapper`}
                      style={{
                        width: "100%",
                        height: "300px",
                        overflow: "hidden",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <ins
                        className="adsbygoogle"
                        style={{
                          display: "block",
                          width: "100%",
                          // maxWidth: "320px",
                          minHeight: "300px",
                          margin: "0 auto",
                        }}
                        data-ad-client="ca-pub-8691062301030113"
                        data-ad-slot="9135916775"
                        // data-ad-format="auto"
                        data-adtest="on"
                        data-full-width-responsive="true"
                      ></ins>
                    </div>
                    <h1 className="adText">{t("Common.Advertisement")}</h1>
                  </div>
                </Col>

                <Col md={8} xs={12} className="userProductContainer">
                  {isLoading ? (
                    <>
                      <ShimmerDiv height={200} width={"100%"} />
                    </>
                  ) : (
                    <>
                      <div style={{ width: "97%" }}>{renderTabContent()}</div>
                    </>
                  )}
                </Col>
              </Row>
              <Row>
                <Col md={4} className="p-0"></Col>
              </Row>
            </div>
          </div> */}
        </>
      )}

      {showModal && (
        <Portal layer="modal">
        <div
          className="modal fade show postAdd wlj-overlay-modal"
          tabIndex="-1"
          role="dialog"
          style={{ display: "flex" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6 className="wlj-modal-title--danger">
                  <PersonRemoveAlt1SharpIcon className="material-symbols-sharp" />
                  {t("modals.Are you sure you want to unfollow")}
                </h6>

                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    handleCloseModal();
                  }}
                />
              </div>

              <div className="col-md-12 text-end d-flex justify-content-end wlj-modal-footer">
                <button type="button"
                  className="wljDangerBtn mt-2"
                  onClick={() => {
                    UnFollowCompany()
                  }}>
                  <PersonRemoveAlt1SharpIcon />
                  {t("Newsfeed.Unfollow")}
                </button>
              </div>
            </div>
          </div>
        </div>
        </Portal>
      )}

      {showReviewModal && (
        <Portal layer="modal">
        <div
          className="modal fade show postAdd wlj-overlay-modal"
          tabIndex="-1"
          role="dialog"
          style={{ display: "flex" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6> {t("Newsfeed.Add Review")}</h6>

                {/* <span
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    handleCloseReviewModal();
                  }}
                >
                  close
                </span> */}
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    handleCloseReviewModal();
                  }}
                />
              </div>

              <div className="col-md-12 mt-2 ">
                <textarea
                  type="text"
                  style={{ width: "100%", height: "100px" }}
                  value={reviewContent}
                  onChange={(e) => setReviewContent(e.target.value)}
                  className="textReview"
                ></textarea>
              </div>
              <div className="col-md-12 text-end">
                <button type="button" className="mainBtn1" onClick={AddReview}>
                  {t("Newsfeed.Save")}
                </button>
              </div>
            </div>
          </div>
        </div>
        </Portal>
      )}

      {openBgModal && !showUpdateModal && !deleteModal && (
        <Portal layer="modal">
        <div
          className="modal fade show postAdd modal-lg wlj-overlay-modal"
          tabIndex="-1"
          role="dialog"
          style={{ display: "flex" }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6>{t("modals.Company Background View")} </h6>
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => handleOpenBgCloseModal()}
                />
              </div>
              <div className="p-2">
                <div className="backrgound-profile-view d-flex justify-content-center">
                  <img src={companyDetails?.backGroundImage} alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
        </Portal>
      )}

      {openProfileModal && !showUpdateModal && !deleteModal && (
        <Portal layer="modal">
        <div
          className="modal fade show postAdd modal-sm wlj-overlay-modal"
          tabIndex="-1"
          role="dialog"
          style={{ display: "flex" }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6>{t("modals.Company Logo")} </h6>
                {/* <span
                  className="material-symbols-sharp me-2 pointer"
                  onClick={handleOpenProfileCloseModal}
                >
                  close
                </span> */}
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={handleOpenProfileCloseModal}
                />
              </div>
              <div className="p-2">
                <div className="profile-view">
                  <img
                    src={companyLogoSrc}
                    alt=""
                    onError={handleCompanyLogoError}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        </Portal>
      )}

      <SuccessToast
        show={showToast}
        message={toastMessage}
        onClose={() => setShowToast(false)}
      />

      <WarningToast
        show={showWarningToast}
        message={warningToastMessage}
        onClose={() => setShowWarningToast(false)}
      />

      <ErrorToast
        show={showErrorToast}
        message={ErrorToastMessage}
        onClose={() => setShowErrorToast(false)}
      />

      {jobModal && <ModalForGuest closeModalData={closeModalData} />}

      {bgModal && (
        <Portal layer="modal">
        <div
          className="modal fade show postAdd wlj-overlay-modal"
          tabIndex="-1"
          role="dialog"
          style={{ display: "flex" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6>{t("modals.Background Image")}</h6>

                {/* <span
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    handleBgModal();
                  }}
                >
                  close
                </span> */}
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    handleBgModal();
                  }}
                />
              </div>

              <div className="uploaded-imagebg mt-2">
                {bgSelectedImage && (
                  <div className="preview-container text-center position-relative d-inline-block" style={{ width: "100%" }}>
                    <img
                      src={bgSelectedImage}
                      alt="Selected"
                      className="img-fluid mb-3 rounded"
                      style={{ width: "100%", maxHeight: "300px" }}
                    />

                    <div className="old-button-area d-flex justify-content-center gap-2">
                      <span
                        className="pointer"
                        style={{ backgroundColor: "gainsboro", padding: "7px 10px 10px 10px", borderRadius: "50%" }}
                        onClick={() => {
                          setBgModal(false);
                          setBgCropImage(bgSourceImage || bgSelectedImage);
                          setBgCroppedAreaPixels(null);
                          setCrop({ x: 0, y: 0 });
                          setZoom(1);
                          setRotation(0);
                          setShowBgCropper(true);
                        }}
                      >
                        <EditSharpIcon className="material-symbols-sharp" />
                      </span>

                      <span
                        className="pointer"
                        style={{ backgroundColor: "gainsboro", padding: "7px 10px 10px 10px", borderRadius: "50%" }}
                        onClick={() => {
                          deleteBgSelection();
                        }}
                      >
                        <DeleteSharpIcon className="material-symbols-sharp" />
                      </span>
                    </div>
                  </div>
                )}
              </div>

              <div className="col-md-12 text-end mt-4">
                <button
                  type="button"
                  className="mainBtn1"
                  onClick={BgImageUpload}
                  disabled={isloading}

                >
                  {/* {t("User Profile.Submit")} */}
                  {isloading === true ? t("User Profile.Submit") : t("User Profile.Submit")}

                </button>
              </div>
            </div>
          </div>
        </div>
        </Portal>
      )}

      {profileModal && (
        <Portal layer="modal">
        <div
          className="modal fade show postAdd wlj-overlay-modal"
          tabIndex="-1"
          role="dialog"
          style={{ display: "flex" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6> {t("modals.Company Profile Pic")} </h6>

                {/* <span
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    handleprofileModal();
                  }}
                >
                  close
                </span> */}
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    handleprofileModal();
                  }}
                />
              </div>
              <div className="d-flex"></div>
              <div className="uploaded-imagebg mt-2">
                {selectedprofileImage && (
                  <div className="preview-container text-center position-relative d-inline-block" style={{ width: "100%" }}>
                    <img
                      src={selectedprofileImage}
                      alt="Selected"
                      className="img-fluid mb-3 rounded"
                      style={{ width: "100%", maxHeight: "300px" }}
                    />

                    <div className="old-button-area d-flex justify-content-center gap-2">
                      <span
                        className="pointer"
                        style={{ backgroundColor: "gainsboro", padding: "7px 10px 10px 10px", borderRadius: "50%" }}
                        onClick={() => {
                          setprofileModal(false);
                          setProfileCropImage(profileSourceImage || selectedprofileImage);
                          setProfileCroppedAreaPixels(null);
                          setCrop({ x: 0, y: 0 });
                          setZoom(1);
                          setRotation(0);
                          setShowProfileCropper(true);
                        }}
                      >
                        <EditSharpIcon className="material-symbols-sharp" />
                      </span>

                      <span
                        className="pointer"
                        style={{ backgroundColor: "gainsboro", padding: "7px 10px 10px 10px", borderRadius: "50%" }}
                        onClick={() => {
                          deleteProfileSelection();
                        }}
                      >
                        <DeleteSharpIcon className="material-symbols-sharp" />
                      </span>
                    </div>
                  </div>
                )}
              </div>

              <div className="col-md-12 text-end mt-4">
                <button
                  type="button"
                  className="mainBtn1"
                  onClick={ProfileImageUpload}
                  disabled={loading}
                >
                  {loading === true ? t("SignIn.Loading") : t("User Profile.Submit")}
                </button>
              </div>
            </div>
          </div>
        </div>
        </Portal>
      )}

      {showProfileCropper && (
        <Portal layer="modal">
        <div
          className="modal fade show postAdd wlj-overlay-modal"
          tabIndex="-1"
          role="dialog"
          style={{ display: "flex" }}
        >
          <div
            className="modal-dialog modal-dialog-centered"
            role="document"
          >
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6>{t("modals.Company Profile Pic")}</h6>
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={cancelProfileCropping}
                />
              </div>
              <div className="cropperContianer">
                {selectedprofileImage && (
                  <div className="crop-app">
                    <div className="bg-crop-wrapper" style={{ position: "relative", height: 400, width: "100%" }}>
                      <Cropper
                        image={profileCropImage || selectedprofileImage}
                        crop={crop}
                        zoom={zoom}
                        style={{ height: 200, width: "100%" }}
                        rotation={rotation}
                        aspect={1 / 1}
                        onCropChange={setCrop}
                        onCropComplete={onProfileCropComplete}
                        onRotationChange={setRotation}
                        onZoomChange={setZoom}
                      />
                    </div>
                  </div>
                )}
              </div>
              <div className="text-end mt-2">
                <button className="closebtn me-2" onClick={cancelProfileCropping}>
                  {t("Connections.Cancel")}
                </button>
                <button className="mainBtn1" onClick={saveProfileCroppedImage}>
                  {t("Newsfeed.Apply Crop")}
                </button>
              </div>
            </div>
          </div>
        </div>
        </Portal>
      )}

      {showBgCropper && (
        <Portal layer="modal">
        <div
          className="modal fade show postAdd wlj-overlay-modal"
          tabIndex="-1"
          role="dialog"
          style={{ display: "flex" }}
        >
          <div
            className="modal-dialog modal-dialog-centered"
            role="document"
          >
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6>{t("modals.Background Image")}</h6>
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={cancelBgCropping}
                />
              </div>
              <div className="cropperContianer">
                {bgSelectedImage && (
                  <div className="crop-app">
                    <div className="bg-crop-wrapper" style={{ position: "relative", height: 400, width: "100%" }}>
                      <Cropper
                        image={bgCropImage || bgSelectedImage}
                        crop={crop}
                        zoom={zoom}
                        style={{ height: 200, width: "100%" }}
                        rotation={rotation}
                        aspect={16 / 4}
                        onCropChange={setCrop}
                        onCropComplete={onBgCropComplete}
                        onRotationChange={setRotation}
                        onZoomChange={setZoom}
                      />
                    </div>
                  </div>
                )}
              </div>
              <div className="text-end mt-2">
                <button className="closebtn me-2" onClick={cancelBgCropping}>
                  {t("Connections.Cancel")}
                </button>
                <button className="mainBtn1" onClick={saveBgCroppedImage}>
                  {t("Newsfeed.Apply Crop")}
                </button>
              </div>
            </div>
          </div>
        </div>
        </Portal>
      )}

      {hasCompanyDetails && <div
        className={`fixed_Scrollbar-UserDetail-Toolbar fixed_Scrollbar-UserDetail-Toolbar2 ${showToolbar ? "show" : "hide"
          }`}
      >
        <div className="fixed_Scrollbar-UserDetail-ToolbarInner">
          <div className="fixed_Scrollbar-UserDetail-Toolbar_Details">
            <div className="fixed_Scrollbar-UserDetail-Toolbar_UserIconBothfixed_Scrollbar-UserDetail-Toolbar_User_Details">
              <div className="fixed_Scrollbar-UserDetail-Toolbar_UserIcon">
                <div
                  className={`profileImg fixed_Scroll`}
                // onClick={() => setOpenProfileModal(true)}
                >
                  <img
                    src={companyLogoSrc}
                    alt=""
                    onError={handleCompanyLogoError}
                  />
                </div>
              </div>
              <div className="fixed_Scrollbar-UserDetail-Toolbar_User_Details">
                <h4>{companyDetails?.compName}</h4>
                <p> {companyDetails?.industryName}</p>
                <div className="fixed_Scrollbar-UserDetail-Toolbar_User_Details_Resume"></div>
              </div>
            </div>
            {companyDetails?.isBlockedByYou !== true && !checkblockC && companyDetails?.isOwned === false && (
            <div className="fixed_Scrollbar-UserDetail-Toolbar_Buttons">
              {companyDetails?.isFollowedByYou === true || followC === true ? (
                <button
                  type="submit"
                  className="wljDangerBtn me-2 wlj-chip-btn"
                  onClick={() => {
                    handleUnfollow();
                  }}
                >
                  <PersonRemoveAlt1SharpIcon />
                  {t("Newsfeed.Unfollow")}
                </button>
              ) : (
                <button
                  className="wljPrimaryBtn me-2 wlj-chip-btn"
                  onClick={() =>
                    guestModeData === "true"
                      ? setJobModal(true)
                      : FollowCompany()
                  }
                >
                  <PersonAddAlt1SharpIcon />
                  {t("Newsfeed.Follow")}
                </button>
              )}
              {jobAlert === "Company job alert found!" ? (
                <button
                  type="submit"
                  className="wljDangerBtn business-action-btn"
                  onClick={() => {
                    handleUnmarkJobAlert();
                  }}
                >
                  {t("Newsfeed.Unmark Job Alert")}

                </button>
              ) : (
                <button
                  className="mainBtn1 me-1 markBtn business-action-btn"
                  onClick={() =>
                    guestModeData === "true"
                      ? setJobModal(true)
                      : markJobAlert()
                  }
                >
                  {t("Newsfeed.Mark Job Alert")}
                </button>
              )}
            </div>
            )}
          </div>
        </div>
      </div>}
    </>
  );
};

export default BusinessPage;
